<template>
  <!-- 党建建设 -->
  <!-- TODO -->
  <div class="box">
    <details-head img="./img/bj3.png" title="行业统计" remarks="Industry Statistics" />
    <TopBreadcrumb :data="[{ label: '产业链情况' }, { label: '行业统计' }]" />
    <div class="con" v-loading="loading">
      <h2 style="font-weight: bold;font-size: 19px;margin-top: 0.1rem;color: #464646;padding-left: 5px;">2022年广州市规划设计行业基本概况</h2>
      <div class="head-echart">
        <div class="chart" :style="{ '--color': '#71cdf4' }">
          <div class="chart-num">{{ data.sumRevenue }}<span >亿</span></div>
          <div class="chart-title">行业营收</div>
        </div>
        <div class="chart" :style="{ '--color': '#5ac464' }">
          <div class="chart-num">{{ data.sumUnit }}</div>
          <div class="chart-title">企业数量</div>
        </div>
        <!-- <div class="chart" :style="{'--color': '#1496fd'}">
          <div class="chart-num">{{data.sumNumber}}</div>
          <div class="chart-title">人员数量</div>
        </div> -->
        <div class="chart" :style="{ '--color': '#e9df71' }">
          <div class="chart-num">{{ data.sumPrize }}</div>
          <div class="chart-title">规上企业数量</div>
        </div> 
        <div class="chart" :style="{ '--color': '#a772dd' }">
          <div class="chart-num">{{ data.sumPatent }}</div>
          <div class="chart-title">专利数量</div>
        </div>
        <!-- <div class="chart" :style="{ '--color': '#e9df71' }">
          <div class="chart-num">{{ data.sumPrize }}</div>
          <div class="chart-title">获奖数量</div>
        </div> -->
      </div>

      <div class="line-echart">
        <!-- <div class="chart" ref="refIndustryRevenue" style="height: 300px"></div> -->
        <!-- <div class="chart" ref="refNumberEnterprise" style="height: 300px"></div> -->
        <!-- <div class="chart" ref="refNumberEmployees" style="height: 300px"></div> -->
        <!-- <div class="chart" ref="refNumberPatents" style="height: 300px"></div> -->
        <!-- <div class="chart" ref="refNumberAwards" style="height: 300px"></div> -->

        <div class="chart" ref="refEChart1" style="height: 300px"></div>
        <div class="chart" ref="refEChart2" style="height: 300px;margin-top: 50px;"></div>
        <!-- <div class="chart" ref="refNumberAwards" style="height: 300px"></div> -->
      </div>
      <div style="text-align: center;margin-top: 0.3rem;">数据来源：广州市统计局、广州市城市规划勘测设计研究院</div>
    </div>
  </div>
</template>

<script>
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
import { list } from "@/api/statistical.js";
import { computed } from "vue";
export default {
  components: { DetailsHead, TopBreadcrumb },
  data() {
    let optionIndustryRevenue = {
      title: {
        text: "广州规划设计企业营收情况",
      },
      xAxis: {
        type: "category",
        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          barWidth: "19px",
          data: [120, 200, 150, 80, 70, 110, 130],
          type: "bar",
        },
      ],
    };
    return {
      loading: false,
      data: {
        sumRevenue: '',
        sumUnit: '',
        sumPatent: '',
        sumPrize: '',
      },
      optionIndustryRevenue,
    };
  },
  mounted() {
    this.initChart();
    this.init();
  },
  methods: {
    initChart() {
      // this.chartIndustryRevenue = this.$echarts.init(
      //   this.$refs.refIndustryRevenue
      // );
      // this.chartIndustryRevenue.setOption(this.getChartOption("行业营收"));
      // this.chartNumberEnterprise = this.$echarts.init(
      //   this.$refs.refNumberEnterprise
      // );
      // this.chartNumberEnterprise.setOption(this.getChartOption("行业企业数量"));
      // this.chartNumberEmployees = this.$echarts.init(
      //   this.$refs.refNumberEmployees
      // );
      // this.chartNumberEmployees.setOption(
      //   this.getChartOption("企业就业总人数")
      // );
      // this.chartNumberPatents = this.$echarts.init(this.$refs.refNumberPatents);
      // this.chartNumberPatents.setOption(this.getChartOption("专利数量"));
      // this.chartNumberAwards = this.$echarts.init(this.$refs.refNumberAwards);
      // this.chartNumberAwards.setOption(this.getChartOption("行业获奖情况"));

      let data = [
        {
          lable: "一等奖",
          data: [
            { lable: '2015', num: 4 },
            { lable: '2017', num: 2 },
            { lable: '2019', num: 2 },
          ]
        },
        {
          lable: "二等奖",
          data: [
            { lable: '2015', num: 6 },
            { lable: '2017', num: 5 },
            { lable: '2019', num: 7 },
          ]
        },
        {
          lable: "三等奖",
          data: [
            { lable: '2015', num: 12 },
            { lable: '2017', num: 16 },
            { lable: '2019', num: 8 },
          ]
        },
      ]
      let data1 = [
        {
          lable: "一等奖",
          data: [
            { lable: '2015', num: 6 },
            { lable: '2017', num: 3 },
            { lable: '2019', num: 14 },
          ]
        },
        {
          lable: "二等奖",
          data: [
            { lable: '2015', num: 11 },
            { lable: '2017', num: 13 },
            { lable: '2019', num: 33 },
          ]
        },
        {
          lable: "三等奖",
          data: [
            { lable: '2015', num: 5 },
            { lable: '2017', num: 21 },
            { lable: '2019', num: 30 },
          ]
        },
        {
          lable: "表扬奖",
          data: [
            { lable: '2017', num: 8 },
            { lable: '2019', num: 5 },
          ]
        },
      ]


      this.eChart1 = this.$echarts.init(this.$refs.refEChart1);
      this.eChart1.setOption(this.getChartOption2({ list: data, title: '广州获得全国优秀工程勘察设计奖数量情况' }));
      this.eChart2 = this.$echarts.init(this.$refs.refEChart2);
      this.eChart2.setOption(this.getChartOption2({ list: data1, title: '广州获得优秀城市规划设计奖数量情况' }));


    },
    init() {
      this.data.sumRevenue = '741.6'
      this.data.sumUnit = '4763'
      this.data.sumPatent = '5294'
      this.data.sumPrize = '399'
      // list().then((res) => {
      //   console.log(res.data);
      //   const { data } = res;
        // this.data = data;
        // this.chartIndustryRevenue.setOption(this.getUpdata(data.yearRevenue));
        // this.chartNumberEnterprise.setOption(this.getUpdata(data.yearUnit));
        // this.chartNumberEmployees.setOption(this.getUpdata(data.yearNumber));
        // this.chartNumberPatents.setOption(this.getUpdata(data.yearPatent));
        // this.chartNumberAwards.setOption(this.getUpdata(data.yearPrize));
      // });
    },

    getUpdata(list) {
      return {
        xAxis: {
          data: list.map((iti) => {
            return iti.year;
          }),
        },
        series: [
          {
            data: list.map((iti) => {
              return iti.sum;
            }),
          },
        ],
      };
    },

    getChartOption(title) {
      return {
        title: {
          text: title,
        },
        xAxis: {
          type: "category",
          data: ["Mon"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            barWidth: "19px",
            data: [100],
            type: "bar",
          },
        ],
      };
    },

    getChartOption2({ list, title }) {
      // 算出最大值
      let max = list.reduce(
        (accumulator, item) => {
          let value = item.data.reduce((dan, item2) => {
            return (item2.num > dan) ? item2.num : dan
          }, 0)
          return (value > accumulator) ? value : accumulator
        },
        0
      );
      max++


      return {

        title: {
          text: title,
        },
        color: ['#5470C6'],
        legend: {
          show: false,
          data: ['现有总计'],
        },
        tooltip: {

        },
        grid: [{
          // top: '8%',
          width: list.length == 3 ? '30%' : '22%',
          right: '5%',
          left: '5%',
          bottom: "15%"

        }, {
          // top: '8%',
          width: list.length == 3 ? '30%' : '22%',
          right: '5%',
          left: list.length == 3 ? '35%' : '27%',
          bottom: "15%"

        }, {
          // top: '8%',
          width: list.length == 3 ? '30%' : '22%',
          right: '5%',
          left: list.length == 3 ? '65%' : '49%',
          bottom: "15%"
        },
        ...(((list) => {
          if (list.length == 3) return []
          return [{
            width: '22%',
            right: '5%',
            left: "71%",
            bottom: "15%"
          }]
        })(list))
        ],
        xAxis: [
          ...list.map((item, i) => {
            return {
              type: 'category',
              gridIndex: i,
              data: item.data.map(item => item.lable),
              axisTick: {
                length: 0,
              }
            }
          }),

          ...list.map((item, i) => {
            return {
              type: 'category',
              gridIndex: i,
              data: [
                {
                  value: item.lable,
                  textStyle: {
                    fontSize: 17,
                    lineHeight: 50
                  }
                }
              ],
              position: 'bottom',
              axisTick: {
                length: 110
              },

            }
          }),
        ],

        yAxis: [{

          type: 'value',
          axisLabel: {
            interval: 0,
          },
          splitLine: {
            show: false
          },
          min: 0,
          max: max,
        },
        {
          show: false,
          gridIndex: 1,
          type: 'value',
          min: 0,
          max: max,

        },
        {
          show: false,
          gridIndex: 2,
          type: 'value',
          min: 0,
          max: max,

        },
        {
          show: false,
          gridIndex: 3,
          type: 'value',
          min: 0,
          max: max,

        },
        ],
        series: [
          ...list.map((item, i) => {
            return {
              barWidth: "19px",
              name: '现有总计',
              xAxisIndex: i,
              yAxisIndex: i,
              data: item.data.map(dat => dat.num),
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
            }
          }),
        ]
      }
    }
  },
};
</script>
 
<style lang="less" scoped>
.con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 30px;
}

.head-echart {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;

  .chart {
    --color: #71cdf4;
    font: 14px/1.6em "Segoe UI", "Microsoft YaHei UI", Arial, "宋体";
    color: #111;
    height: 150px;
    width: 150px;
    border-radius: 100%;
    border: 2px solid var(--color);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    padding-top: 20px;
    box-sizing: border-box;
    color: var(--color);

    .chart-num {
      font-size: 30px;
      >span{
        font-size: 18px;
      }
    }

    .chart-title {
      font-size: 20px;
    }
  }
}

.line-echart {
  margin-top: 90px;
  width: 100%;
  flex-direction: column;
  gap: 20px;
  // .item {
  //   width: 100%;
  //   position: relative;
  //   display: flex;
  //   flex-direction: column;

  //   .name {
  //     font-size: 30px;
  //     font-weight: bold;
  //     padding: 20px;
  //     // width: 50%;
  //   }
  .chart {
    height: 250px;
    width: 100%;
    // width: 50%;
  }

  // }
}
</style>